export type VariationDescriptor = { textureId: number; variationUUID: string };

export const FeaturedTemplateVariations: Record<string, VariationDescriptor> = {
  get A(): VariationDescriptor {
    return {
      textureId: 4716,
      variationUUID: '9ae196ec-b996-4123-beab-d632b75528c3',
    };
  },
  get B(): VariationDescriptor {
    return {
      textureId: 31,
      variationUUID: '0fcb9808-3728-4a33-b592-a24bd0656823',
    };
  },
  get C(): VariationDescriptor {
    return {
      textureId: 3888,
      variationUUID: '785e57cb-1563-47db-8199-b9b7c904d657',
    };
  },
  get D(): VariationDescriptor {
    return {
      textureId: 4031,
      variationUUID: 'f1c68f50-a95a-4b8f-8486-fa9fe1679009',
    };
  },
  get E(): VariationDescriptor {
    return {
      textureId: 1220,
      variationUUID: '2efc3469-dc73-4f35-8016-8af45b8d81e9',
    };
  },
  get F(): VariationDescriptor {
    return {
      textureId: 1229,
      variationUUID: '35d7f4d8-88cd-40c4-84b4-3d4778add3a2',
    };
  },
  get G(): VariationDescriptor {
    return {
      textureId: 1232,
      variationUUID: '1d496e36-518e-4d10-966d-aa82daaa9e6e',
    };
  },
  get H(): VariationDescriptor {
    return {
      textureId: 1223,
      variationUUID: '748ba67c-cfcb-4dc2-990e-b024329d24b1',
    };
  },
  get I(): VariationDescriptor {
    return {
      textureId: 2816,
      variationUUID: '64b3cf15-a2d6-4f7b-adad-37c084f99143',
    };
  },
  get J(): VariationDescriptor {
    return {
      textureId: 139,
      variationUUID: 'df8e046b-d505-4cfe-ac8c-bdaa1af3da28',
    };
  },
};
